const menuAccount = function () {
    if (document.body.classList.contains('logged-in')) {
        if (document.body.classList.contains('woocommerce-account')) {
            const menuIconOpen = document.querySelector('.woocommerce-account .article-h1');
            const menu = document.querySelector('.woocommerce-MyAccount-navigation');
            const menuIconClose = document.createElement('span');
            menuIconClose.textContent = '\u2716';
            menu.prepend(menuIconClose);
            menuIconOpen.addEventListener('click', function () {
                menu.classList.toggle('open');
            })
            menuIconClose.addEventListener('click', function () {
                menu.classList.toggle('open');
            })
        }
    }
}

addFunctionOnWindowLoad(menuAccount);